import React from 'react';

import { Address } from 'api/api';

import { formatAddress } from '~address-form/utils/format';

import { useGlobalState, useSessionState } from '../global-state';

interface LocationAddressProps {
  address?: Address;
  showCity?: boolean; // show city by default
}

export const LocationAddress: React.FC<LocationAddressProps> = ({ address, showCity = true }) => {
  const globalState = useGlobalState();
  const session = useSessionState();

  if (!address) {
    return null;
  }

  // location address is different than search address in format.
  const addressText = formatAddress(address, {
    country: globalState.purchase_country,
    show_street: true,
    show_city: showCity,
    show_postal_code: session.flags.enable_postal_code_in_location_address,
    show_region: session.flags.enable_postal_code_in_location_address,
  });
  return <span>{addressText}</span>;
};
